import { ToolbarGroup } from "@wordpress/components";
import { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useImageContext } from "../context/ImageContext";
import { getImageHubSettings } from "../context/useSettings";
import { PROVIDERS } from "../helpers";
import { CustomToolbarButton } from "./CustomToolbarButton";
import QueryFilters from "./QueryFilters";
import { CustomSearchButton } from "./SearchButton";

import { __ } from "@wordpress/i18n";

const ProvidersAndFilters = ({ media = false }) => {
	const {
		lastSearchTerm,
		searchTerm,
		setSearchTerm,
		images,
		provider,
		setProvider,
		fetchImages,
		handleSearch,
		pagination,
		isLoading,
		setAdditionalQueryParams

	} = useImageContext();
	const { imageHubSettings } = getImageHubSettings();

	const [underlineStyle, setUnderlineStyle] = useState({ left: 20, width: 101 });
	const toolbarRef = useRef(null);
	const buttonRefs = useRef({});

	useLayoutEffect(() => {
		if (!provider || !toolbarRef.current) return;

		const selectedButton = buttonRefs.current[provider.toLowerCase()];

		if (selectedButton && toolbarRef.current) {
			const buttonRect = selectedButton.getBoundingClientRect();
			const toolbarRect = toolbarRef.current.getBoundingClientRect();

			setUnderlineStyle({
				left: buttonRect.left - toolbarRect.left,
				width: buttonRect.width
			});
		}

		const resizeObserver = new ResizeObserver(() => {
			if (selectedButton && toolbarRef.current) {
				const buttonRect = selectedButton.getBoundingClientRect();
				const toolbarRect = toolbarRef.current.getBoundingClientRect();

				setUnderlineStyle({
					left: buttonRect.left - toolbarRect.left,
					width: buttonRect.width
				});
			}
		});

		resizeObserver.observe(toolbarRef.current);

		return () => {
			resizeObserver.disconnect();
		};
	}, [provider, isLoading]);


	useEffect(() => {
		Object.entries(imageHubSettings).forEach(([key, value]) => {
			if (key.includes("image_hub_enable_")) {
				const providerKey = key
					.replace("image_hub_enable_", "")
					.toUpperCase();
				if (PROVIDERS?.[providerKey]) {
					PROVIDERS[providerKey].enabled = value;
				}
			}
		});

		PROVIDERS.All.enabled =
			Object.values(PROVIDERS).filter(
				(x) => x.name !== "All" && x.enabled,
			).length !== 1;

		setProvider(
			Object.values(PROVIDERS).filter((x) => x.enabled)[0]?.name || "",
		);
	}, [imageHubSettings]);

	return (
		<div className="image-hub-toolbar-sticky">
			<ToolbarGroup
				className={
					media
						? "image-hub-toolbar image-hub-toolbar-white"
						: "image-hub-toolbar"
				}
			>
				<div ref={toolbarRef}>
					{Object.keys(PROVIDERS).map((prov) => {
						if (!PROVIDERS[prov].enabled) return null;
						return (
							<CustomToolbarButton
								key={prov}
								ref={(el) =>
									(buttonRefs.current[
										PROVIDERS[prov].name.toLowerCase()
									] = el)
								}
								selected={
									prov?.toLowerCase() ==
									provider?.toLowerCase()
								}
								icon={
									PROVIDERS[prov].icon
										? PROVIDERS[prov].icon
										: undefined
								}
								onClick={() => {
									setProvider(PROVIDERS[prov].name);
									setAdditionalQueryParams({});
									setTimeout(() => {
										fetchImages(
											searchTerm?.toLowerCase(),
											PROVIDERS[prov].name,
											1,
											true,
											{},
										);
									}, 400);
								}}
								label={
									prov == "All"
										? "All Libraries"
										: prov.charAt(0)?.toUpperCase() +
											prov.slice(1)?.toLowerCase()
								}
							></CustomToolbarButton>
						);
					})}
					{provider == "giphy" && (
						<a
							href="https://giphy.com/"
							target="_blank"
							className="image-hub-giphy-attribution"
						>
							<img src={image_hub_data.giphyAttrUrl}></img>
						</a>
					)}
					<div
						style={{
							position: "absolute",
							left: 0,
							background: "#d3d3d3",
							width: "100%",
							height: "2px",
							bottom: 0,
						}}
					>
						<div
							className="image-hub-floating-underline"
							style={{
								left: `${underlineStyle.left}px`,
								width: `${underlineStyle.width}px`,
							}}
						/>
					</div>
				</div>
			</ToolbarGroup>
			<ToolbarGroup className="image-hub-toolabar-query">
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						justifyContent: "end",
						alignItems: "end",
						gap: "10px",
						width: "100%",
						// height: "65px"
					}}
				>
					<div
						style={{
							minWidth:
								(provider == PROVIDERS.UNSPLASH.name &&
									!lastSearchTerm) ||
								["All", "giphy"].includes(provider)
									? "100%"
									: "250px",
						}}
					>
						<CustomSearchButton
							value={searchTerm || ""}
							onSubmit={(val) => {
								setSearchTerm(val);
								handleSearch(val);
							}}
							onChange={(val) => {
								setSearchTerm(val);
							}}
							onBlur={() => {
								if (
									searchTerm.replaceAll(" ", "") !=
									lastSearchTerm.replaceAll(" ", "")
								) {
									handleSearch();
								}
							}}
							onClear={() => {
								setAdditionalQueryParams({});
							}}
						/>
					</div>
					{provider == PROVIDERS.UNSPLASH.name && !lastSearchTerm ? (
						""
					) : (
						<QueryFilters media={media} />
					)}
				</div>
				{!isLoading &&
					searchTerm &&
					searchTerm.replace(/\s+/g, "").length > 0 &&
					lastSearchTerm.toLowerCase() ==
						searchTerm.toLowerCase() && (
						<p
							style={{
								color: "rgb(152, 151, 157)",
								margin: "0.5em 0",
							}}
						>
							{localStorage.getItem("imageHubDevMode") ==
								"true" && (
								<span style={{ color: "red" }}>
									{images.length}/
								</span>
							)}

							<strong style={{ color: "black" }}>
								{pagination.totalResults ||
									__("No results", "image-hub")}
							</strong>
							{__(" image(s) found for ", "image-hub")}
							<strong style={{ color: "black" }}>
								{lastSearchTerm}
							</strong>
						</p>
					)}
			</ToolbarGroup>
			{isLoading && (
				<div className="image-hub-progress-bar">
					<div className="image-hub-progress-bar-inner"></div>
				</div>
			)}
		</div>
	);
};

export default ProvidersAndFilters;
